import React from 'react';
import { Attributes, Filter } from 'jobs.types';
import { useTranslation } from 'react-i18next';
import {
  BEFRISTUNG_ATTRIBUTE_ID,
  HOMEOFFICE_ATTRIBUTE_ID,
  RESET_ATTRIBUTE_ID,
} from '../../constants';

interface Props {
  attributes: Attributes;
  filter: Filter;
  onChange: (attributeId: string, elementId: string) => void;
}

const AboTogglesAdditional = ({ attributes, filter, onChange }: Props) => {
  const { t } = useTranslation('jobs');

  return (
    <div>
      <h3 className="h3">{t('filters_additional')}</h3>
      <ul className="abotogglegroup__toggle-list">
        {attributes[BEFRISTUNG_ATTRIBUTE_ID]?.values
          .filter(({ id }) => id !== RESET_ATTRIBUTE_ID)
          .map(({ name, id }) => (
            <li key={id} className="abotogglegroup__toggle-item">
              <input
                id={id}
                checked={!!filter.jobAbo[BEFRISTUNG_ATTRIBUTE_ID]?.includes(id)}
                type="checkbox"
                className="abotogglegroup__toggle-field"
                onChange={() => onChange(BEFRISTUNG_ATTRIBUTE_ID, id)}
              />
              <label htmlFor={id} className="abotogglegroup__toggle-label">
                {name}
              </label>
            </li>
          ))}
        <li key="homeoffice" className="abotogglegroup__toggle-item">
          <input
            id="homeoffice"
            checked={!!filter.jobAbo[HOMEOFFICE_ATTRIBUTE_ID]?.includes('1')}
            type="checkbox"
            className="abotogglegroup__toggle-field"
            onChange={() => onChange(HOMEOFFICE_ATTRIBUTE_ID, '1')}
          />
          <label htmlFor="homeoffice" className="abotogglegroup__toggle-label">
            {attributes[HOMEOFFICE_ATTRIBUTE_ID]?.name}
          </label>
        </li>
      </ul>
    </div>
  );
};

export default AboTogglesAdditional;
